import { Component } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';

@Component({
    selector: 'app-session-expired-modal',
    templateUrl: './session-expired-modal.component.html',
    imports: [MatButton, MatDialogTitle, MatDialogContent, MatDialogActions]
})
export class SessionExpiredModalComponent {

    constructor(private dialogRef: MatDialogRef<SessionExpiredModalComponent>) {}

    login(): void {
        this.dialogRef.close(true);
    }
}
